import React, {useContext, useEffect} from "react"
import  '../styles/Sort.scss'
import { SortContext } from "../context/SortContext"
import { ModalContext } from "../context/ModalContext";
import Modal from './Modal';


const Sort = () => {

    const sortProviderValues = useContext(SortContext)
    const modalProviderValues = useContext(ModalContext);

    console.log("SortContext:", sortProviderValues);

    
    return      <React.Fragment>                
                    <Modal isOpen={modalProviderValues.isModalSortOpen} onClose={() => 
                        modalProviderValues.setIsModalSortOpen(false)}>
                            <div className="sort-container">   
                                <h2>Sort Expenses</h2>                                                     
                                <div className="sort-date">
                                    <label>
                                    <input
                                        type="radio"
                                        name="sort"
                                        value="date-dec"
                                        checked={sortProviderValues.selectedSort === "date-dec"}
                                        onChange={e => {
                                            sortProviderValues.onSortChange(e.target.value);
                                        }}
                                    />
                                    <span>By date: newest first</span>
                                    </label>
                                </div>                                
                                <div className="sort-date">
                                    <label>
                                    <input
                                        type="radio"
                                        name="sort"
                                        value="date-inc"
                                        checked={sortProviderValues.selectedSort === "date-inc"}
                                        onChange={e => {
                                            sortProviderValues.onSortChange(e.target.value);
                                        }}
                                    />
                                    <span>By date: oldest first</span>
                                    </label>
                                </div>                                
                                <div className="sort-expense">
                                    <label>
                                    <input
                                        type="radio"
                                        name="sort"
                                        value="expense"
                                        checked={sortProviderValues.selectedSort === "expense"}
                                        onChange={e => {
                                            sortProviderValues.onSortChange(e.target.value);
                                        }}
                                    />
                                    <span>By expense name</span> <i className="material-icons">sort_by_alpha</i>
                                    </label>
                                </div>                                
                                <div className="sort-price">
                                    <label>
                                    <input
                                        type="radio"
                                        name="sort"
                                        value="price-inc"
                                        checked={sortProviderValues.selectedSort === "price-inc"}
                                        onChange={e => {
                                            sortProviderValues.onSortChange(e.target.value);
                                        }}
                                    />
                                    <span>Price ascending</span> <i className="material-icons">arrow_upward</i>
                                    </label>
                                </div>                                
                                <div className="sort-price">
                                    <label>
                                    <input
                                        type="radio"
                                        name="sort"
                                        value="price-dec"
                                        checked={sortProviderValues.selectedSort === "price-dec"}
                                        onChange={e => {
                                            sortProviderValues.onSortChange(e.target.value);
                                        }}
                                    />
                                    <span>Price descending</span> <i className="material-icons">arrow_downward</i>
                                    </label>
                                </div>                                                
                            </div>                       
                    </Modal>   
                </React.Fragment>
}
    
export {Sort}